import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { SupportTicket } from '../entities/SupportTicket'

// The requester is `args.user`, never a client-supplied field.
@InputType()
export class CreateSupportTicketArgs extends ActionArgs {
  @Field(() => String)
  subject: string

  @Field(() => String)
  content: string
}

export interface ICreateSupportTicket extends IAction<SupportTicket, CreateSupportTicketArgs> {}
